import { ActiveBundlePageTypeKeys } from '@/store';
import { bundleTypeMap } from '../constants';
import { api } from '../core';

interface UpdateChronologyEntryPagesResponse {
  success: boolean;
}

interface UpdateChronologyEntryPagesProps {
  abortController?: AbortController;
  entryId: string;
  bundlePageType: ActiveBundlePageTypeKeys;
  newPageNumbers: number[];
}

const chronologyEntryPagesUpdateApi = api.injectEndpoints({
  endpoints: (builder) => ({
    updateChronologyEntryPages: builder.query<UpdateChronologyEntryPagesResponse, UpdateChronologyEntryPagesProps>({
      query: ({
        abortController = new AbortController(),
        entryId,
        bundlePageType,
        newPageNumbers
      }: UpdateChronologyEntryPagesProps) => ({
        url: 'chronology/entry/pages/update',
        method: 'POST',
        body: {
          entry_id: entryId,
          bundle_type_to_add_from: bundleTypeMap[bundlePageType],
          new_page_numbers: newPageNumbers
        },
        signal: abortController.signal
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in updateChronologyEntryPages in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyUpdateChronologyEntryPagesQuery } = chronologyEntryPagesUpdateApi;
